import { Select } from 'ui/selectv2/Select';
import { TableCell } from 'ui/tableCell';
import { FormField } from 'ui/formField';
import { BoldText } from 'ui/theme/typography/components';
import { disableSelectOptions } from './DefineFieldTypes.utils';
import { FIELD_TYPES_SELECT_OPTIONS } from '../constants';
import type { FieldTableColumnData } from '../types';

export const FIELD_TYPE_TABLE_COLUMNS_VIEW_MODE_1_SAMPLE: FieldTableColumnData[] = [
  {
    name: 'Field name',
    align: 'flex-start',
    value: 'fieldName',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.fieldName}</TableCell>,
  },
  {
    name: 'Field type',
    align: 'flex-start',
    value: 'fieldType',
    sortable: false,
    RowCell: ({ row }) => (
      <TableCell data-test="define-field-type-fieldType-view">{row.fieldType}</TableCell>
    ),
  },
  {
    name: 'Sample data',
    align: 'flex-start',
    value: 'sample1',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.sample1}</TableCell>,
  },
];

export const FIELD_TYPE_TABLE_COLUMNS_VIEW_MODE_2_SAMPLES: FieldTableColumnData[] = [
  ...FIELD_TYPE_TABLE_COLUMNS_VIEW_MODE_1_SAMPLE,
  {
    name: '',
    align: 'flex-start',
    value: 'sample2',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.sample2}</TableCell>,
  },
];

export const configureFieldTypeTableColumnsEdit = (
  showSingleSample: boolean,
  onSelect: (selectedType: any, fieldName: string) => void,
): FieldTableColumnData[] => {
  const with1Sample: FieldTableColumnData[] = [
    {
      name: 'Field name',
      align: 'flex-start',
      value: 'fieldName',
      sortable: false,
      RowCell: ({ row }) => <TableCell>{row.fieldName}</TableCell>,
    },
    {
      name: 'Field type',
      align: 'flex-start',
      value: 'fieldType',
      sortable: false,
      RowCell: ({ row }) => {
        return (
          <TableCell data-test="define-field-type-fieldType-define">
            <FormField
              isHorizontalLayout
              labelText="Select field type"
              restrictionText="Type can only be defined once"
            >
              <Select
                isClearable
                onSelect={([selectedType]) => onSelect(selectedType?.value, row.fieldName)}
                options={disableSelectOptions(row.fieldName)}
                usePortal
                value={[FIELD_TYPES_SELECT_OPTIONS.find((o) => o.value === row.fieldType)]}
              />
            </FormField>
          </TableCell>
        );
      },
    },
    {
      name: 'Sample data',
      align: 'flex-start',
      value: 'sample1',
      sortable: false,
      RowCell: ({ row }) => <TableCell>{row.sample1}</TableCell>,
    },
  ];

  return showSingleSample
    ? with1Sample
    : [
        ...with1Sample,
        {
          name: '',
          align: 'flex-start',
          value: 'sample2',
          sortable: false,
          RowCell: ({ row }) => <TableCell>{row.sample2}</TableCell>,
        },
      ];
};

export const FIELD_TYPE_TABLE_COLUMNS_CONFIRM_MODE_2_SAMPLES: FieldTableColumnData[] = [
  {
    name: 'Field name',
    align: 'flex-start',
    value: 'fieldName',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.fieldName}</TableCell>,
  },
  {
    name: 'Field type',
    align: 'flex-start',
    value: 'fieldType',
    sortable: false,
    RowCell: ({ row }) => (
      <TableCell data-test="define-field-type-fieldType-confirm">
        {row.fieldType ? <BoldText>{row.fieldType}</BoldText> : 'undefined'}
      </TableCell>
    ),
  },
  {
    name: 'Sample data',
    align: 'flex-start',
    value: 'sample1',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.sample1}</TableCell>,
  },
  {
    name: '',
    align: 'flex-start',
    value: 'sample2',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.sample2}</TableCell>,
  },
];

export const FIELD_TYPE_TABLE_COLUMNS_CONFIRM_MODE_1_SAMPLE: FieldTableColumnData[] = [
  ...FIELD_TYPE_TABLE_COLUMNS_CONFIRM_MODE_2_SAMPLES,
  {
    name: '',
    align: 'flex-start',
    value: 'sample2',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.sample2}</TableCell>,
  },
];
